import { useCallback, useState } from 'react'

const STORAGE_KEY = 'market_sidebar_collapsed'

const readStored = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

const writeStored = (collapsed: boolean) => {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
  } catch {
    // ignore quota / private mode
  }
}

/** Desktop sidebar collapse preference shared by AppShell and OperatorShell. */
export const useSidebarCollapsed = () => {
  const [collapsed, setCollapsedState] = useState(readStored)

  const setCollapsed = useCallback((next: boolean) => {
    setCollapsedState(next)
    writeStored(next)
  }, [])

  const toggleCollapsed = useCallback(() => {
    setCollapsedState((current) => {
      const next = !current
      writeStored(next)
      return next
    })
  }, [])

  return { collapsed, setCollapsed, toggleCollapsed }
}
